// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';

import ebanxLogoSrc from './ebanx-logo.svg';

export function EbanxLogo(): Node {
  return <Img src={ebanxLogoSrc} />;
}

const Img = styled.img`
  display: inline;
  height: 1em;
  margin: 0 2px;
`;
